// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Content__popover-bf03cf {
  background-color: var(--base-10);
  z-index: 1;
  padding: 6px;
  border: 1px solid var(--base-30);
  box-sizing: border-box;
  box-shadow: var(--box-shadow-popover);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/TextFormattingMenu/Content/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,UAAA;EACA,YAAA;EAEA,gCAAA;EACA,sBAAA;EACA,qCAAA;EACA,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,mBAAA;AADF","sourcesContent":[".popover {\n  background-color: var(--base-10);\n  z-index: 1;\n  padding: 6px;\n\n  border: 1px solid var(--base-30);\n  box-sizing: border-box;\n  box-shadow: var(--box-shadow-popover);\n  border-radius: 8px;\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `Content__popover-bf03cf`
};
module.exports = ___CSS_LOADER_EXPORT___;
